import TableReportHelper from "report/helper"
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport"
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport"
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport"
import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport"

export default async function pragaSoloReport(indicador, visita) {
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor
    const apontamentos = visita.getApontamentosByIndicador(indicador)
    const content = []

    for (const apontamento of apontamentos) {
        // let showObservacao = false // removido para o indicador pragaSolo
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const configIndicador = {
            showTrator: false,
            showImplemento: false,
            showFrente: false,
            addHeaderField: [
                {
                    field: "talhao.area", label: "Área do Talhão (ha)", width: 90, valueGetter: (a) => {
                        let sumArea = 0

                        if (a.talhao.length) {
                            for (let i = 0; i < a.talhao.length; i++) {
                                sumArea = sumArea + parseFloat(a.talhao[i].area)
                            }

                            return sumArea.toFixed(2)
                        } else {
                            return a.talhao.area
                        }
                    },
                },
                { field: "totalTocosAvaliados", label: "Total de Tocos Avaliados", width: 70 },
                { field: "totalTocosDanificados", label: "Total de Tocos Danificados", width: 70 },
            ]
        }

        content.push(
            [
                await apontamentoHeaderLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    params,
                    "Conformidade", // label da conformidade
                    configIndicador,
                ),

                await apontamentoColetasLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    ["Tocos Avaliados", "Sphenophorus", "Hyponeuma", "Migdolus", "Outros", "Tocos Danificados"],
                    (h) => [
                        h.numberField("tocosAvaliados",),
                        h.numberField("pragaSphenophorus",),
                        h.numberField("pragaHyponeuma",),
                        h.numberField("pragaMigdolus",),
                        h.numberField("outrasPragas",),
                        h.numberField("tocosDanificados",),
                    ],
                    ['*', '*', '*', 35, 35, '*'],
                    // showObservacao
                ),
                apontamentoImagesReport(visita, indicador, apontamento),
                apontamentoObservacaoReport(visita, indicador, apontamento),

                h.space(),
            ]
        )
    }

    return content
}
